import { debounceTime, filter, map, switchMap } from 'rxjs/operators';

import { createAssistRequest } from '../../../../redux/epics/helpers/request.helper';
import * as assistTripActions from './assistTrip.actions';

export const assistRequestEpic = (action$, store) =>
  action$.pipe(
    filter(assistTripActions.addAssist.match),
    filter(() => !store.value.assistTrip.completed),
    debounceTime(200),
    switchMap(() => createAssistRequest(store)),
    map(payload => assistTripActions.completeLoading(payload)),
  );
